/** Internal-only VOD/candidate diagnostics UI (system admin tooling). */
export function isLscVodDiagnosticsUiEnabled(): boolean {
  return String(process.env.REACT_APP_ENABLE_LSC_VOD_DIAGNOSTICS_UI ?? '')
    .trim()
    .toLowerCase() === 'true';
}
